{
  "actions": "Åtgärder",
  "hideButtonLabel": "Visa mindre",
  "noTags": "Ingen",
  "showAllButtonLabel": "Visa alla ({tagCount, number})"
}
